export default __webpack_public_path__ + "static/media/12.ce8ce665.jpg";